import requestConfig from '@/../requestConfig.js'

import axios from 'axios'

function http (vue) {

  this.vue = vue

  this.parseUrl = function (url) {
    const res = requestConfig.url + url.replace('-', '/') + '.html'
    return res
  }

  this.parseData = function (data) {
    const res = new FormData()
    if (!data) return ''
    for (const i in data) {
      res.append(i, data[i])
    }
    return res
  }

  this.request = function (url, options) {
    const method = options.method || 'GET'
    const data = this.parseData(options.data)
    const headers = options.headers || { 'content-type': 'application/x-www-form-urlencoded' }
    return axios({
      method: method,
      url: this.parseUrl(url),
      data: data,
      headers: headers
    })
  }

  this.post = function (url, data, headers, hideLoading) {
    const options = { method: 'POST' }
    if (data) options.data = data
    if (headers) options.headers = headers
    if (!hideLoading) this.vue.$vs.loading({ type: 'radius' })
    return new Promise((resolve, reject) => {
      this.request(url, options).then(response => {
        const res = response.data
        res.code = parseInt(res.code)
        this.vue.$vs.loading.close()
        if (res.code === -1) {
          this.vue.$router.push({ name: 'pageLogin' })
          reject(res.message)
        } else if (res.code === 0) {
          this.vue.$vs.dialog({
            title: '提示',
            text: res.message,
            acceptText: '确认'
          })
          reject(res.message)
        } else if (res.code === 1) {
          resolve(res.message)
        }
        reject(response.data)
      })
      .catch((error) => {
        this.vue.$vs.loading.close()
        reject(error)
      })
    })
  }

  this.get = function (url, data, headers, hideLoading) {
    const options = { method: 'GET' }
    if (data) options.data = data
    if (headers) options.headers = headers
    if (!hideLoading) this.vue.$vs.loading({ type: 'radius' })
    return new Promise((resolve, reject) => {
      this.request(url, options).then(response => {
        const res = response.data
        res.code = parseInt(res.code)
        this.vue.$vs.loading.close()
        if (res.code === -1) {
          this.vue.$router.push({ name: 'pageLogin' })
          reject(res.message)
        } else if (res.code === 0) {
          reject(res.message)
        } else if (res.code === 1) {
          resolve(res.message)
        }
        reject(response.data)
      })
      .catch(function (error) {
        this.vue.$vs.loading.close()
        reject(error)
      })
    })
  }

  // 添加零
  this.addZero = function(str, length) {
    str += ''
    while(str.length<length) {
      str = '0' + str
    }
    return str
  }

}


export default http
